import React from 'react';

const RoleBadge = ({ role, className = '' }) => {
  if (!role) {
    return null;
  }

  const tagClass = {
    'Owner': 'tag',
    'Admin': 'tag btn-pill-green',
    'Member': 'tag tag-grey',
  }[role] || 'tag tag-grey';

  return (
    <span className={`${tagClass} ${className}`.trim()}>
      {role}
    </span>
  );
};

export default RoleBadge;
